/* eslint-disable no-console */
import { List } from 'immutable';
import { Provider } from 'react-redux';
import { useLocation, Outlet } from 'react-router';
import { MpdToastProvider } from '@mapado/makeup';
// eslint-disable-next-line import/no-unresolved
import { PdfLiveRendering } from '@mapado/seating/demo-specific';
import { SeatConfigShape } from './DemoTypes';
import configureStore from './config/configureStore';
import { getLongId } from './utils/entity';

const store = configureStore();

interface Props {
  seatConfigList: List<SeatConfigShape>;
  isLivePdfRendering: boolean;
}

export type OutletContextType = {
  seatConfigList: List<SeatConfigShape>;
  selectedSeatConfig: undefined | SeatConfigShape;
};

export default function DemoContent({
  seatConfigList,
  isLivePdfRendering,
}: Props): JSX.Element {
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);

  let selectedSeatConfig: undefined | SeatConfigShape;

  if (searchParams.has('seatConfigId')) {
    selectedSeatConfig = seatConfigList.find(
      (sc) =>
        sc['@id'] ===
        getLongId(
          '/v1/seat_configs/',
          searchParams.get('seatConfigId') as string
        )
    );
  } else if (searchParams.has('index')) {
    selectedSeatConfig = seatConfigList
      .sortBy((seatConfig) => seatConfig.label)
      .get(Number(searchParams.get('index') as string));
  } else {
    selectedSeatConfig = seatConfigList.first();
  }

  return (
    <Provider store={store}>
      <MpdToastProvider>
        <div className="seating-demo-root__tabContent">
          <div className="seating-demo__withPdfPreview">
            <div>
              <Outlet
                context={
                  {
                    seatConfigList,
                    selectedSeatConfig,
                  } satisfies OutletContextType
                }
              />
            </div>

            {isLivePdfRendering && <PdfLiveRendering />}
          </div>
        </div>
      </MpdToastProvider>
    </Provider>
  );
}
